module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "epub:type": "toc",
      "id": "table-of-contents",
      "role": "doc-toc"
    }
  }, [_c('div', {
    staticClass: "toc-heading"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("by Ken Foree")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/chokepoint"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chokepoint")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/fatgirlwithaknife"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Fat Girl with a Knife")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/lonegunman"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Lone Gunman")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/notthiswarnotthisworld"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Not this War, Not this World")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/callingdeath"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Calling Death")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/gavinfunkesmonstermoviemarathon"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Gavin Funke’s Monster Movie Marathon")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/cadaverdog"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Cadaver Dog")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/overduebooks"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Overdue Books")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/asmalltasteoftheoldcountry"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("A Small Taste of the Old Country")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/sisters",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Sisters")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/jackandjill"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Jack and Jill")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thewindthroughthefence"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The Wind Through the Fence")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/jingoandthehammerman"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Jingo and the Hammerman")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thedeathpoemofsenseiotoro"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The Death Poem of Sensei Ōtoro")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/sonofthedevil"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Son of the Devil")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/peglegandpaddysavetheworld"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Pegleg And Paddy Save the World")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheauthor"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ifyouliked"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("If You Liked …")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/otherwordfirepresstitles"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Other WordFire Press Titles")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007288a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0